import { createRouter, createWebHistory } from 'vue-router'

import ChannelsView from '../views/ChannelsView.vue';
import HomeView from '../views/HomeView.vue';
import VideoView from '../views/VideoView.vue';
import MdmSetup from '../views/MdmSetup.vue';
import Login from '../views/Login.vue';
import NotFoundView from '../views/NotFoundView.vue';
import {RouteNames} from './routeNames';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: RouteNames.Channels,
      component: ChannelsView
    },
    {
      path: '/channels/:channelId',
      name: RouteNames.Channel,
      component: HomeView
    },
    {
      path: '/videos/:videoId',
      name: RouteNames.Video,
      component: VideoView
    },
    {
      path: '/mdm',
      name: RouteNames.MdmSetup,
      component: MdmSetup
    },
    {
      path: '/login',
      name: RouteNames.Login,
      component: Login,
      meta: {
        requiresNotProd: true,
      }
    },
    {
      path: '/:catchAll(.*)',
      name: RouteNames.NotFound,
      component: NotFoundView
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  // Don't allow access to certain routes in production - e.g. The manual login
  if (to.meta.requiresNotProd && process.env.NODE_ENV === 'production') {
    return next({name: RouteNames.NotFound})
  }

  next()
})

export default router
